export default __webpack_public_path__ + "static/media/doctor-placeholder-male.a00b56c9.jpg";